import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import useNaturezaJuridicas from "core/features/cnae/hooks/useNaturezaJuridicas";

export interface SelectNaturezaJuridicaProps<T = any> extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectNaturezaJuridica({ value, onChange, ...rest }: SelectNaturezaJuridicaProps) {
  const { isLoading, data } = useNaturezaJuridicas();

  return (
    <SelectBaseAntd
      loading={isLoading}
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={data?.map((item) => ({
        value: item.id,
        label: item.nome,
      }))}
      {...rest}
    />
  );
}

export default SelectNaturezaJuridica;
